import './headerDivider.scss';

export default function HeaderDivider() {
    return <div className='an-header-divider'></div>;
}
